"use client";

import Loading from "@/components/ui/Loading";
import { useAuth } from "@/context/AuthContext";
import { useRouter } from "@/i18n/navigation";
import { useEffect } from "react";
import { useTranslations } from "next-intl";

/**
 * Gate de las rutas privadas (FEATURE-029): **solo** verifica sesión Cognito y
 * redirige a login si falta. Sin chrome visual (cada zona privada trae el suyo;
 * hoy la única es el admin `/app`, que monta su propia consola).
 *
 * Bypass de desarrollo (FEATURE-014): con `NEXT_PUBLIC_DEV_BYPASS_TOKEN` activo se
 * saltea el gate (en local no hay Cognito real). Nunca en producción.
 */
export default function PrivateLayoutClient({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, loading, user } = useAuth();
  const router = useRouter();
  const t = useTranslations("auth");
  const devBypass = !!process.env.NEXT_PUBLIC_DEV_BYPASS_TOKEN;

  useEffect(() => {
    if (devBypass) return;
    if (!router || loading) return;
    if (!isAuthenticated()) router.replace("/login");
  }, [router, loading, isAuthenticated, devBypass]);

  if (loading && !devBypass) return <Loading message={t("verifyingSession")} />;
  if (!user && !devBypass) return null;

  return <>{children}</>;
}
